import { useEffect } from "react";
import { initAnalytics, setAnalyticsConsent } from "../lib/analytics";

const CONSENT_KEY = "yaba_consent_v1";

/**
 * Reads persisted consent from localStorage on mount and, if present,
 * initializes GA4 + Meta Pixel accordingly.
 * Renders nothing.
 */
export function AnalyticsBootstrap() {
  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(CONSENT_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return;
      const next = {
        analytics: !!parsed.analytics,
        marketing: !!parsed.marketing,
      };
      setAnalyticsConsent(next);
      initAnalytics(next);
    } catch {
      /* ignore */
    }
  }, []);
  return null;
}

export { CONSENT_KEY };
